module.exports = __webpack_public_path__ + "img/evernote.png";